
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  getHotelSearchList } from '../../services/hotel/hotelServices';

export const fetchHotelList = createAsyncThunk('hotel/fetchHotelList', async (searchTerm, { rejectWithValue }) => {
  try {
    const response = await getHotelSearchList(searchTerm);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

const hotelSlice = createSlice({
  name: 'hotel',
  initialState: {
    hotelList: null,
    loading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchHotelList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHotelList.fulfilled, (state, action) => {
        state.loading = false;
        state.hotelList = action.payload;
      })
      .addCase(fetchHotelList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default hotelSlice.reducer;
